module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-top-ties-remnants.fd848bc2.png";